export default {
    list: [],
    total: 0,
    page: 1,
}
